import { CallAPI } from "../../apiManager/ApiCall";
import {
  addPinURL,
  addSlideURL,
  addSubTitleURL,
  addTitleURL,
  editPinURL,
  getSlideByIdURL,
  getTitleURL,
  swapTitleURL,
} from "../../apiManager/APIConfig";
import { setTitle } from "../../redux/slices/titleSlice";
import { store } from "../../redux/store";

export const GetTitlesCall = async (lang, type) => {
  try {
    const response = await CallAPI({
      url: `${getTitleURL}?lang=${lang}&type=${type}`,
      method: "GET",
    });
    if (!response?.status) {
      store.dispatch(setTitle(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const AddTitlesCall = async (body) => {
  try {
    const response = await CallAPI({ url: addTitleURL, method: "POST", body });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const AddSlideCall = async (body) => {
  try {
    const response = await CallAPI({ url: addSlideURL, method: "POST", body });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const AddSubTitlesCall = async (body) => {
  try {
    const response = await CallAPI({ url: addSubTitleURL, method: "POST", body });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const EditSubTitlesCall = async (body) => {
  try {
    const response = await CallAPI({ url: `${addSubTitleURL}`, method: "PUT", body });
    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const EditTitlesCall = async (body) => {
  try {
    const response = await CallAPI({ url: `${addTitleURL}`, method: "PUT", body });
    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const DeleteTitlesCall = async (body) => {
  try {
    const response = await CallAPI({ url: `${addTitleURL}/${body?.id}`, method: "DELETE" });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const DeleteSubTitlesCall = async (body) => {
  try {
    const response = await CallAPI({ url: `${addSubTitleURL}/${body?.id}`, method: "DELETE" });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const GetSlideByIdCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${getSlideByIdURL}?id=${body?.id}&lang=${body?.lang}`,
      method: "GET",
    });

    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const AddPinCall = async (body) => {
  try {
    const response = await CallAPI({ url: addPinURL, method: "POST", body });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const EditPinCall = async (body) => {
  try {
    const response = await CallAPI({ url: `${editPinURL}`, method: "PUT", body });

    GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const DeletePinCall = async (id) => {
  try {
    const response = await CallAPI({ url: `${editPinURL}/${id}`, method: "DELETE" });

    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const SwapTitlesCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${swapTitleURL}`,
      method: "PUT",
      body,
    });
    GetTitlesCall(body?.lang, body?.type);

    return response;
  } catch (error) {
    return { status: 400 };
  }
};
